export const SHOPIFY_PAGES_CONNECTION: string = 'SHOPIFY_PAGES_CONNECTION'
export const SHOPIFY_ARTICALS_CONNECTION: string = 'SHOPIFY_ARTICALS_CONNECTION'
export const SHOPIFY_PRODUCTS_CONNECTION: string = 'SHOPIFY_PRODUCTS_CONNECTION'
